<template>
  <div class="book-page">
    <section class="hero">
      <div class="container">
        <div class="hero-content">
          <h1>Book: "The Ascent Framework"</h1>
          <p>Proven strategies for building better construction companies.</p>
        </div>
      </div>
    </section>

    <section class="book-details">
      <div class="container">
        <div class="book-info">
          <img src="@/assets/images/book-cover.jpg" alt="The Ascent Framework Book Cover" />
          <div class="book-description">
            <h2>The Ascent Framework: A Proven System for Building Better Construction Companies</h2>
            <p class="author">By John Smith, Founder & CEO of Ascent Consulting</p>
            <p class="price">$29.99</p>
            <p>Based on over a decade of experience working with contractors across North America, "The Ascent Framework" provides a comprehensive system for transforming your construction company into a high-performance organization.</p>
            
            <h3>What You'll Learn:</h3>
            <ul>
              <li>The 5 pillars of construction company excellence</li>
              <li>How to align your team around shared goals and values</li>
              <li>Proven methods for improving operational efficiency</li>
              <li>Strategies for leveraging technology to drive results</li>
              <li>Frameworks for making better financial decisions</li>
              <li>Case studies from successful contractors</li>
            </ul>
            
            <div class="cta-buttons">
              <button class="buy-btn">Buy Now</button>
              <button class="download-btn">Download Sample Chapter</button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="testimonials">
      <div class="container">
        <h2>What Readers Are Saying</h2>
        <div class="testimonial-list">
          <div class="testimonial">
            <blockquote>
              "This book completely changed how I think about running my business. The frameworks are practical and immediately applicable."
            </blockquote>
            <p class="author">— Mike Johnson, President of BuildRight Construction</p>
          </div>
          
          <div class="testimonial">
            <blockquote>
              "As someone who's been in the industry for 30 years, I thought I'd seen it all. This book taught me new strategies that have already improved our profitability."
            </blockquote>
            <p class="author">— Sarah Williams, CEO of Williams & Associates</p>
          </div>
          
          <div class="testimonial">
            <blockquote>
              "The Ascent Framework is now required reading for all our managers. It's that good."
            </blockquote>
            <p class="author">— David Chen, Operations Director at MegaBuild Corp</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'BookPage'
}
</script>

<style scoped>
.hero {
  background-image: url('@/assets/images/book-hero.jpg');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 8rem 0;
  text-align: center;
  position: relative;
  width: 100%;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 1rem;
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.hero p {
  font-size: 1.2rem;
}

.book-details {
  background-color: black;
  color: white;
  padding: 6rem 0;
}

.book-info {
  display: flex;
  gap: 3rem;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.book-info img {
  flex: 1;
  max-width: 300px;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.book-description {
  flex: 2;
}

.book-description h2 {
  font-size: 2rem;
  margin-bottom: 1rem;
}

.author {
  color: #aaa;
  font-size: 1.1rem;
  margin-bottom: 1rem;
}

.price {
  font-size: 1.5rem;
  color: var(--primary-color);
  margin-bottom: 1.5rem;
}

.book-description p {
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 1.5rem;
}

.book-description h3 {
  font-size: 1.5rem;
  margin: 2rem 0 1rem;
}

.book-description ul {
  list-style: none;
  padding-left: 0;
  margin-bottom: 2rem;
}

.book-description ul li {
  margin-bottom: 0.5rem;
  position: relative;
  padding-left: 1.5rem;
}

.book-description ul li::before {
  content: "✓";
  color: var(--accent-red);
  position: absolute;
  left: 0;
  font-size: 1.2rem;
}

.cta-buttons {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.buy-btn {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.buy-btn:hover {
  background-color: var(--secondary-color);
}

.download-btn {
  background-color: transparent;
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
  padding: 0.75rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s;
}

.download-btn:hover {
  background-color: var(--primary-color);
  color: white;
}

.testimonials {
  background-color: var(--bg-light);
  color: black;
  padding: 6rem 0;
}

.testimonials h2 {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
}

.testimonial-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.testimonial {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.testimonial blockquote {
  font-style: italic;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  position: relative;
}

.testimonial blockquote::before {
  content: '"';
  font-size: 3rem;
  position: absolute;
  left: -1.5rem;
  top: -1rem;
  color: #ddd;
}

.author {
  text-align: right;
  font-weight: bold;
  color: #555;
}

@media (max-width: 768px) {
  .hero h1 {
    font-size: 2.5rem;
  }

  .book-info {
    flex-direction: column;
    text-align: center;
  }
  
  .book-info img {
    max-width: 250px;
    margin: 0 auto;
  }
  
  .book-description {
    text-align: left;
  }
  
  .cta-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .buy-btn, .download-btn {
    width: 100%;
    max-width: 300px;
  }
}
</style>